<template>
<div  class="carClassOut">
    <div class="carClass">
      <div class="classCon">
        <div class="classC_lf">
          <p class="carClass_p wow fadeInUp">我要买车</p>
          <div class="classC_btn wow fadeInUp">
            <span class="classCbtn1"  @click="todealer()">经销商查询</span>
            <span class="classCbtn1" @click="toconsultation()">购车咨询</span>
          </div>
        </div>
        <div class="classC_rg">
          <p class="carClass_p wow fadeInUp">我是车主</p>
          <div class="classC_btn wow fadeInUp">
            <span class="classCbtn1" @click="toActiv()">服务活动</span>
            <span class="classCbtn1" @click="toSupplier()">售后服务</span>
          </div>
        </div>
      </div>
    </div>
    <p class="carClass_more1 "><span class="wow fadeInUp">了解更多</span></p>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
  export default {
    data () {
      return {


      }
    },
    created () {
    },

    mounted () {
// 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })
    },
    methods: {
      todealer(){
        this.$router.push({
            name: 'dealer',
            query: {
              // type: type,
            },
          })
      },
      toSupplier(){
        this.$router.push({
            name: 'supplier',
            query: {
            },
          })
      },
      toconsultation(){
        this.$router.push({
            name: 'consultation',
            query: {
              // type: type,
            },
          })
      },
      toActiv(){
        this.$router.push({
            name: 'serActivity',
            query: {
            },
          })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home/class.vue